if (!customElements.get('varia-knowledge')) {
  class VariaKnowledge extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.status = this.querySelector('.vk-status');
      this.results = this.querySelector('.vk-results');
      this.onSubmit = event => { event.preventDefault(); this.search(); };
      this.onClick = event => {
        const topic = event.target.closest('[data-query]');
        if (topic) { this.input.value = topic.dataset.query; this.search(); }
        if (event.target.closest('[data-open-support]')) {
          const status = this.querySelector('.vk-support-status');
          if (typeof window.zE === 'function') {
            try { window.zE('messenger', 'open'); status.textContent = 'Varia Support is opening.'; }
            catch { status.textContent = 'Please use Contact Varia while support chat is unavailable.'; }
          } else { status.textContent = 'Support chat is still loading or unavailable. Please use Contact Varia.'; }
        }
      };
      this.form.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.form?.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('click', this.onClick);
      this.connected = false;
    }
    async search() {
      const query = this.input.value.trim();
      if (query.length < 2) { this.input.reportValidity(); return; }
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      const timeout = setTimeout(() => controller.abort('timeout'), 15000);
      this.status.textContent = 'Searching Varia knowledge…';
      this.results.replaceChildren();
      this.results.setAttribute('aria-busy', 'true');
      const url = new URL(this.dataset.endpoint);
      url.searchParams.set('query', query.slice(0, 250));
      url.searchParams.set('locale', this.dataset.locale);
      url.searchParams.set('per_page', '12');
      try {
        const response = await fetch(url, { credentials: 'omit', signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (this.controller !== controller) return;
        const seen = new Set();
        let count = 0;
        for (const article of data.results || data.articles || []) {
          if (article.draft || article.user_segment_id != null) continue;
          let source;
          try { source = new URL(article.html_url); } catch { continue; }
          if (source.protocol !== 'https:' || source.hostname !== 'variabrewing.zendesk.com') continue;
          const title = String(article.title || article.name || 'Varia guidance');
          if (seen.has(title)) continue;
          seen.add(title);
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          summary.textContent = title;
          const answer = document.createElement('div');
          answer.className = 'vk-answer';
          const paragraph = document.createElement('p');
          const parsed = new DOMParser().parseFromString(String(article.body || ''), 'text/html');
          parsed.querySelectorAll('script,style,iframe,object,embed').forEach(node => node.remove());
          parsed.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
          parsed.querySelectorAll('p,li,h1,h2,h3,h4').forEach(node => node.append('\n'));
          paragraph.textContent = (parsed.body.textContent || '').replace(/\n{3,}/g, '\n\n').trim() || 'Open the source article for this guidance.';
          const link = document.createElement('a');
          link.href = source.href;
          link.textContent = 'Read the source in Varia knowledge ↗';
          link.target = '_blank'; link.rel = 'noopener';
          answer.append(paragraph, link); details.append(summary, answer); this.results.append(details);
          count += 1;
          if (count === 8) break;
        }
        this.status.textContent = count ? `${count} ${count === 1 ? 'answer' : 'answers'} from Varia knowledge. Select a question to read more.` : 'No matching answer yet. Try your product name, or ask Varia below.';
      } catch (error) {
        if (this.controller !== controller || !this.isConnected) return;
        this.status.textContent = 'Search is temporarily unavailable. Try again, or use Ask Varia or Contact Varia below.';
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) this.results.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('varia-knowledge', VariaKnowledge);
}
